import './footerSignature.css';
import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import LogoOld from './assets/download.svg';
// Social icons show at 18 px: 72 px WebP copies, not the 500+ px PNGs.
import InstaIcon from './assets/icon/social/instagram_c-72.webp';
import FacebookIcon from './assets/icon/social/facebook_c-72.webp';
import PinterestIcon from './assets/icon/social/pinterest_c-72.webp';
import TwitterIcon from './assets/icon/social/twitter_c-72.webp';
import YoutubeIcon from './assets/icon/social/youtube_c-72.webp';
import WhatsappIcon from './assets/icon/social/whatsapp_c-72.webp';
import RazorpayIcon from './assets/logo/razorpay_w.svg';
import VisaIcon from './assets/logo/visa.svg';
import MastercardIcon from './assets/logo/mastercard.svg';
import RupayIcon from './assets/logo/rupay.svg';
import UpiIcon from './assets/logo/upi.svg';
import PhonePeIcon from './assets/logo/phonepe.svg';
import GooglePayIcon from './assets/logo/google_pay.svg';
import FooterNewsletter from './FooterNewsletter';

export default function Foot() {
  return (
    <div className="new-footer-wrapper w-full bg-[#0f0e0d] flex flex-col justify-end font-body">
      <style>{`
        @keyframes gold-shimmer {
          0% { border-color: rgba(212,169,95,0.25); box-shadow: 0 0 5px rgba(212,169,95,0.1); }
          50% { border-color: rgba(212,169,95,0.8); box-shadow: 0 0 15px rgba(212,169,95,0.3); }
          100% { border-color: rgba(212,169,95,0.25); box-shadow: 0 0 5px rgba(212,169,95,0.1); }
        }
        .gold-animated-box {
          animation: gold-shimmer 3s infinite ease-in-out;
        }

        .footer-brand-mark {
          isolation: isolate;
          overflow: hidden;
          border-radius: 10px;
          box-shadow: 0 0 0 1px rgba(212,169,95,0.12), 0 18px 38px rgba(0,0,0,0.35);
        }

        .footer-brand-mark::before {
          content: '';
          position: absolute;
          inset: -36%;
          z-index: 0;
          background: radial-gradient(circle, rgba(212,169,95,0.28) 0%, rgba(212,169,95,0.08) 34%, transparent 64%);
          opacity: 0.55;
          animation: footer-logo-halo 5.8s ease-in-out infinite;
        }

        .footer-brand-mark::after {
          content: '';
          position: absolute;
          inset: -55% -140%;
          z-index: 1;
          background: linear-gradient(110deg, transparent 38%, rgba(255,244,218,0.34) 49%, rgba(212,169,95,0.2) 54%, transparent 64%);
          transform: translateX(-42%) rotate(8deg);
          animation: footer-logo-sweep 6.4s cubic-bezier(0.22, 1, 0.36, 1) infinite;
          pointer-events: none;
        }

        .footer-brand-logo {
          filter: drop-shadow(0 0 8px rgba(212,169,95,0.28));
          transform: scale(1);
        }

        @keyframes footer-logo-halo {
          0% { transform: scale(0.82); opacity: 0.24; }
          46% { transform: scale(1.08); opacity: 0.7; }
          82% { transform: scale(1.18); opacity: 0; }
          100% { transform: scale(1.18); opacity: 0; }
        }

        @keyframes footer-logo-sweep {
          0%, 20% { transform: translateX(-44%) rotate(8deg); opacity: 0; }
          38% { opacity: 0.9; }
          58%, 100% { transform: translateX(44%) rotate(8deg); opacity: 0; }
        }

        .new-footer-wrapper button {
          background: transparent;
          border: none;
          box-shadow: none;
          padding: 0;
        }

        .new-footer-wrapper,
        .new-footer-wrapper footer {
          background-color: #0f0e0d !important;
        }

        .new-footer-wrapper input {
          box-shadow: none !important;
        }

        .new-footer-wrapper input:focus {
          outline: none !important;
          box-shadow: none !important;
          border-color: #d4a95f !important;
        }

        .newsletter-input {
          background-color: rgba(255,255,255,0.04) !important;
          color: #f7f1e8 !important;
          border: 1px solid rgba(212,169,95,0.22) !important;
        }

        .newsletter-input::placeholder {
          color: rgba(247,241,232,0.38) !important;
        }

        .newsletter-button {
          background: linear-gradient(135deg, #d8af68, #c59445) !important;
          color: #15110c !important;
          border: none !important;
          padding-left: 2rem !important;
          padding-right: 2rem !important;
          min-width: 120px;
          font-size: 0.75rem !important;
          letter-spacing: 0.12em !important;
        }

        .newsletter-button:hover {
          background: linear-gradient(135deg, #ddb36e, #cb9a4d) !important;
        }

        .social-icon-img {
          filter: none;
        }

        .footer-gold-top {
          width: 100%;
          height: 1px;
          background: linear-gradient(90deg, transparent 0%, rgba(212,169,95,0.4) 28%, rgba(212,169,95,0.82) 50%, rgba(212,169,95,0.4) 72%, transparent 100%);
        }

        .footer-link-item a {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          text-decoration: none;
          color: rgba(247,241,232,0.68);
          transition: color 0.2s, padding-left 0.2s;
          font-size: 0.85rem;
          line-height: 1.6;
        }

        .footer-link-item a:hover {
          color: #d4a95f;
          padding-left: 4px;
        }

        .footer-link-item a::before {
          content: '';
          display: inline-block;
          width: 0;
          height: 1px;
          background: #d4a95f;
          transition: width 0.25s;
          flex-shrink: 0;
        }

        .footer-link-item a:hover::before {
          width: 10px;
        }

        .footer-scroll-top {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: 1px solid rgba(212,169,95,0.34) !important;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.2s, border-color 0.2s;
          flex-shrink: 0;
        }

        .footer-scroll-top:hover {
          background: rgba(212,169,95,0.12) !important;
          border-color: #d4a95f !important;
        }

        .animate-marquee {
          display: inline-flex;
          animation: marquee 18s linear infinite;
        }

        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .underline-bar {
          background: #d4a95f;
          transform-origin: center;
          transform: scaleX(0);
          animation: underlinePulse 3.8s ease-in-out infinite;
        }

        @keyframes underlinePulse {
          0% { transform: scaleX(0); opacity: 0; }
          20% { transform: scaleX(1); opacity: 1; }
          80% { transform: scaleX(1); opacity: 1; }
          100% { transform: scaleX(0); opacity: 0; }
        }
      `}</style>
      <Footer />
    </div>
  );
}

function Footer() {
  const logoRef = useRef(null);

  const socialLinks = [
    { src: InstaIcon, alt: 'Instagram', href: 'https://www.instagram.com/maviinci_in/' },
    { src: FacebookIcon, alt: 'Facebook', href: 'https://www.facebook.com/share/15DXLNZj4E/' },
    { src: PinterestIcon, alt: 'Pinterest', href: 'https://in.pinterest.com/maviincifashion/' },
    { src: TwitterIcon, alt: 'X', href: 'https://x.com/maviincifashion?t=3Hy6jKr1NxuBUemXqMeYUA&s=08' },
    { src: YoutubeIcon, alt: 'YouTube', href: 'https://www.youtube.com/@maviincifashion' },
    { src: WhatsappIcon, alt: 'WhatsApp', href: 'https://wa.me/918871081395' },
  ];

  const footerSections = [
    {
      title: 'Custom Tailor',
      items: [
        { label: 'Suit', href: '/custom/suit/select_cloth/personalize' },
        { label: 'Formal Wear', href: '/custom/formal/select_cloth/personalize' },
        { label: 'Blazer', href: '/custom/blazer/select_cloth/personalize' },
        { label: 'Ethnic Set (Kurta Pajama)', href: '/custom/ethnic/select_cloth/personalize' },
        { label: 'Standalone Kurta', href: '/custom/only_kurta/select_cloth/personalize' },
        { label: 'Pajama', href: '/custom/pajama/select_cloth/personalize' },
        { label: 'Shirt', href: '/custom/shirt/select_cloth/personalize' },
        { label: 'Trouser', href: '/custom/pant/select_cloth/personalize' },
        { label: 'Jacket / Sadri', href: '/custom/sadri/select_cloth/personalize' },
        { label: 'Vest Coat', href: '/custom/vestcoat/select_cloth/personalize' },
      ],
    },
    {
      title: 'Collections',
      items: [
        { label: 'Designer / Exclusive', href: '/products' },
        { label: 'Kurta Collections', href: '/products/kurta' },
        { label: 'Suit Collections', href: '/products/suit' },
        { label: 'Formal Wear', href: '/products/formal' },
        { label: 'Ethnic Sets', href: '/products/ethnic%20set' },
        { label: 'Sadri Collections', href: '/products/sadri' },
      ],
    },
    {
      title: 'Solutions',
      items: [
        { label: 'Wedding Outfit Planner', href: '/wedding-outfit-planner' },
        { label: 'Uniform Supplier (Business)', href: '/clothing-for-business' },
        { label: 'Send Your Design Photo', href: '/send-your-design' },
        { label: 'Smart Kiosk Franchise', href: '/smart-kiosk-franchise' },
        { label: 'Campus Suit Stalls', href: '/campus-suit-stalls' },
      ],
    },
    {
      title: 'Company',
      items: [
        { label: 'About Us', href: '/about' },
        { label: 'Blog', href: '/blog' },
        { label: 'Embroidery Guide', href: '/blog/embroidery-guide' },
        { label: 'Suit vs Blazer Guide', href: '/blog/suit-blazer-bandhgala' },
      ],
    },
    {
      title: 'Support',
      items: [
        { label: 'Size Chart & Find My Size', href: '/size-chart' },
        { label: 'Terms and Conditions', href: '/terms' },
        { label: 'Privacy Policy', href: '/privacy' },
        { label: 'Shipping & Delivery', href: '/shipping' },
        { label: 'Cancellation Policy', href: '/cancellation' },
        { label: 'Return & Refund Policy', href: '/returns' },
        { label: 'Contact Us', href: '/reachus' },
      ],
    },
  ];

  const paymentIcons = [
    { src: RazorpayIcon, alt: 'Razorpay', href: 'https://razorpay.com/' },
    { src: UpiIcon, alt: 'UPI', href: 'https://www.npci.org.in/what-we-do/upi/product-overview' },
    { src: PhonePeIcon, alt: 'PhonePe', href: 'https://www.phonepe.com/' },
    { src: GooglePayIcon, alt: 'Google Pay', href: 'https://pay.google.com/' },
    { src: VisaIcon, alt: 'Visa', href: 'https://www.visa.co.in/' },
    { src: MastercardIcon, alt: 'Mastercard', href: 'https://www.mastercard.co.in/' },
    { src: RupayIcon, alt: 'RuPay', href: 'https://www.rupay.co.in/' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        window.dispatchEvent(
          new CustomEvent('footer-logo-visibility', {
            detail: {
              visible: entry.isIntersecting,
              ratio: entry.intersectionRatio,
            },
          })
        );
      },
      {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '0px',
      }
    );

    if (logoRef.current) observer.observe(logoRef.current);
    return () => { if (logoRef.current) observer.unobserve(logoRef.current); };
  }, []);

  return (
    <footer className="bg-[#0f0e0d] text-slate-100 w-full">

      {/* Gold accent top line */}
      <div className="footer-gold-top" />

      <div className="mx-auto max-w-[98%] xl:max-w-[1600px] px-[10px] lg:px-8 pt-14 pb-10">

        {/* ── Top Row: Brand + Newsletter ── */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10 pb-12 border-b border-[rgba(212,169,95,0.1)]">

          {/* Brand side */}
          <div className="flex flex-col gap-4 max-w-sm items-start">
            <motion.div
              className="footer-brand-mark relative flex items-center justify-center w-20 h-20 bg-[rgba(255,255,255,0.03)] mb-2"
              initial={{ opacity: 0, y: 10, scale: 0.96 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: false, amount: 0.35 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              {/* The M is sewn: a gold thread draws it, it fills, a glint
                  passes, then it is sewn again (footerSignature.css). */}
              <span className="fbm-seam" aria-hidden="true" />
              <span className="fbm-glint" aria-hidden="true" />
              <svg className="absolute inset-0 z-20 w-full h-full" viewBox="0 0 80 80">
                <motion.rect
                  x="1" y="1" width="78" height="78" rx="8"
                  fill="none"
                  stroke="rgba(212,169,95,0.6)"
                  strokeWidth="1.5"
                  initial={{ pathLength: 0, opacity: 0.4 }}
                  animate={{ pathLength: [0, 1, 1, 1], opacity: [0.25, 1, 0.86, 0] }}
                  transition={{ duration: 6.4, ease: "easeInOut", repeat: Infinity, times: [0, 0.38, 0.82, 1] }}
                />
                <motion.rect
                  x="5" y="5" width="70" height="70" rx="7"
                  fill="none"
                  stroke="rgba(255,235,190,0.2)"
                  strokeWidth="0.75"
                  initial={{ pathLength: 0, opacity: 0 }}
                  animate={{ pathLength: [0, 0.75, 1, 1], opacity: [0, 0.5, 0.28, 0] }}
                  transition={{ duration: 6.4, ease: "easeInOut", repeat: Infinity, delay: 0.32, times: [0, 0.42, 0.78, 1] }}
                />
              </svg>

              <motion.svg
                viewBox="0 0 841.89 595.28"
                className="footer-brand-logo h-12 w-auto object-contain relative z-10"
                initial={{ opacity: 0, scale: 0.92 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.35 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                <g>
                  {[
                    "M271.42,89.36c-57.44,53.74-87.68,125.67-90.12,198.53c-2.43,72.86,22.92,146.65,76.64,204.11l0.3-0.29 v-20.99c-88.19-105.57-82.74-261.7,12.77-360.86l130.08,139.11l9.02-9.02L271.42,89.36z",
                    "M271.15,130.99c-37.59,43.96-59.16,99.46-61.12,157.86c-1.9,57.14,15.09,112.76,48.21,158.55v-26.05 c-23.53-39.54-35.47-85.57-33.9-132.01c1.63-49.34,18.45-97.21,47.67-136.48l108.82,116.38l10.13-10.13L271.15,130.99z",
                    "M273.73,175.66c-21.39,34-33.74,73.92-35.09,114.14c-1.15,34.33,5.71,68.97,19.6,100.36v-45.05 c-4.11-17.94-5.91-36.37-5.3-54.82c1.06-31.56,9.16-62.57,23.59-90.68l84.04,89.88l10.12-10.12L273.73,175.66z",
                    "M647.24,287.89c-2.45-72.86-32.68-144.79-90.12-198.53L417.3,238.83l10.13,10.13l130.09-139.09 c95.51,99.16,100.96,255.29,12.77,360.86v20.99l0.3,0.29C624.32,434.54,649.67,360.75,647.24,287.89z",
                    "M570.3,447.4c33.12-45.79,50.12-101.4,48.21-158.55c-1.96-58.4-23.53-113.9-61.12-157.86L437.57,259.1 l10.13,10.13l108.82-116.38c29.22,39.26,46.04,87.13,47.67,136.48c1.57,46.44-10.36,92.47-33.9,132.01V447.4z",
                    "M570.3,390.17c13.89-31.39,20.74-66.03,19.6-100.36c-1.35-40.22-13.7-80.15-35.09-114.14l-96.98,103.69 l10.12,10.12L552,199.61c14.43,28.11,22.53,59.12,23.59,90.68c0.62,18.45-1.19,36.89-5.3,54.82V390.17z"
                  ].map((path, i) => (
                    <path
                      key={i}
                      d={path}
                      pathLength="1"
                      className="fbm-path"
                      style={{ "--i": i }}
                    />
                  ))}
                </g>
              </motion.svg>
            </motion.div>
            <p className="text-[rgba(247,241,232,0.68)] text-sm leading-relaxed">
              Bespoke tailoring crafted to your measurement. Premium fabrics, fine finishing, and a fit made only for you.
            </p>
            <p className="foot-motto">The fit is <em>Maviinci.</em></p>
          </div>

          {/* Newsletter side */}
          <div className="flex flex-col gap-3 lg:items-end">
            <p className="text-xs uppercase tracking-[0.22em] text-[#fff9ee] font-semibold">Stay in the loop</p>
            <p className="text-[rgba(247,241,232,0.6)] text-sm lg:text-right">New collections, exclusive launches and offers — straight to your inbox.</p>
            <FooterNewsletter />
          </div>
        </div>

        {/* ── Links Grid ── */}
        <div className="foot-grid mt-12 grid gap-6 md:gap-8 text-sm grid-cols-1 md:grid-cols-2 lg:grid-cols-6">
          {footerSections.map((section) => (
            <FooterSection key={section.title} title={section.title}>
              <ul className="space-y-1 !list-none !p-0 !m-0">
                {section.items.map((item, idx) => (
                  <li key={`${section.title}-${idx}`} className="footer-link-item">
                    <a href={item.href}>{item.label}</a>
                  </li>
                ))}
              </ul>
            </FooterSection>
          ))}

          <FooterSection title="Contact Us">
            <div className="flex flex-col gap-3">
              <div>
                <p className="text-[rgba(247,241,232,0.68)] text-sm leading-relaxed">
                  Shanti Nagar Bhilai-3,<br />Dist-Durg, Chhattisgarh 490021
                </p>
              </div>
              <a
                href="mailto:connect@bluepearlindustries.com"
                className="text-sm text-[rgba(247,241,232,0.8)] hover:text-[#d4a95f] transition-colors break-all"
                style={{textDecoration:'none'}}
              >
                connect@bluepearlindustries.com
              </a>
              <a
                href="tel:+918871081395"
                className="text-sm text-[rgba(247,241,232,0.8)] hover:text-[#d4a95f] transition-colors"
                style={{textDecoration:'none'}}
              >
                +91-8871081395
              </a>
            </div>
          </FooterSection>
        </div>

        {/* ── Social + Payment Row ── */}
        <div className="foot-meta mt-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8 border-t border-[rgba(212,169,95,0.1)] pt-8">
          <div className="flex flex-col items-center md:items-start gap-3">
            <p className="text-xs uppercase tracking-[0.22em] text-[rgba(247,241,232,0.55)]">Follow Us</p>
            <div className="flex gap-2.5 flex-wrap justify-center md:justify-start">
              {socialLinks.map((item) => (
                <a
                  key={item.alt}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={item.alt}
                  className="w-9 h-9 bg-white/[0.06] rounded-full flex items-center justify-center hover:bg-[#d4a95f] transition-colors group border border-[rgba(212,169,95,0.12)]"
                >
                  <img src={item.src} alt={item.alt} width="18" height="18" loading="lazy" decoding="async" className="social-icon-img w-[18px] h-[18px] opacity-75 group-hover:opacity-100" />
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col items-center md:items-end gap-3">
            <p className="text-xs uppercase tracking-[0.22em] text-[rgba(247,241,232,0.55)]">We Accept</p>
            <div className="flex gap-3 flex-wrap justify-center md:justify-end items-center">
              {paymentIcons.map((item) => (
                <a key={item.alt} href={item.href} target="_blank" rel="noreferrer" className="inline-flex items-center opacity-78 hover:opacity-100 transition-opacity">
                  <img src={item.src} alt={item.alt} loading="lazy" decoding="async" className="h-5 w-auto" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className="border-t border-[rgba(212,169,95,0.1)] pt-5 flex flex-col items-center text-center w-full">
        <div className="flex flex-col md:flex-row items-center justify-between w-full max-w-[98%] xl:max-w-[1600px] px-[10px] lg:px-8 mb-4 gap-4">
          <p className="text-xs text-[rgba(247,241,232,0.42)]">© {new Date().getFullYear()} Blue Pearl Industries. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <button
              className="footer-scroll-top"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              aria-label="Back to top"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4a95f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="18 15 12 9 6 15" />
              </svg>
            </button>
          </div>
        </div>

        <div className="w-full pb-[30px] sm:pb-[50px] flex flex-col items-center">
          <img
            ref={logoRef}
            src={LogoOld}
            alt="MAVIINCI"
            className="w-full max-w-[98%] xl:max-w-[1600px] h-auto mx-auto mb-4 object-contain px-[10px] lg:px-8"
          />
          <div className="foot-seam relative mt-1 w-full max-w-[98%] xl:max-w-[1600px] h-[2px] overflow-hidden px-[10px] lg:px-8">
            <div className="absolute inset-0 mx-auto underline-bar" />
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterSection({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="foot-col border-b border-white/10 pb-4 md:border-none md:pb-0">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between text-left md:pointer-events-none group outline-none"
      >
        <div className="foot-col__title md:mb-4">{title}</div>
        <span className="text-xl md:hidden text-[#d4a95f]">{open ? '−' : '+'}</span>
      </button>

      <div className={`overflow-hidden transition-all duration-300 md:block ${open ? 'max-h-60 mt-2' : 'max-h-0 md:max-h-none'}`}>
        {children}
      </div>
    </div>
  );
}
